export default __webpack_public_path__ + "static/figma-text-7be36a2f1a76fa08b8c8eefa54eac653.gif";